module.exports = __webpack_public_path__ + "img/spotify.b3c799e0.svg";